import { combineReducers } from 'redux-immutable';
import { routerReducer } from 'react-router-redux';
import pacerSearchResults from './pacerSearchResults';
import caseLookupSearchReducer from './caseLookupSearchReducer';
import reportsTabReducer from './reportsTabReducer';
import searchErrors from './searchErrors';
import validationErrors from './validationErrors';
import loadingSpinner from './loadingSpinner';
import user from './user';
import immediateSearch from './immediateSearch';
import sidebarData from './sidebarReducer';
import kloudless from './kloudlessReducer';
import irSearch from './irSearchReducer';
import integrations from './integrationsReducer';
import docketReducer from './docketReducer';
import history from './historyReducer';
import { automatedReports, templateAlerts, customAlerts } from './searchAlertsReducer';
import clientCodeReducer from './clientCodeReducer';
import creditorMailing from './creditorMailingReducer';
import localCourtSearch from './localCourtSearchReducer';
import advancedSearch from './advancedSearchReducer';
import relatedTransactions from './relatedTransactionReducer';
import claimDocuments from './claimDocumentsReducer';

export default combineReducers({
  routerReducer,
  pacerSearchResults,
  caseLookupSearchReducer,
  reportsTabReducer,
  searchErrors,
  validationErrors,
  loadingSpinner,
  user,
  irSearch,
  immediateSearch,
  sidebarData,
  kloudless,
  integrations,
  clientCodeReducer,
  dockets: docketReducer,
  history,
  automatedReports,
  templateAlerts,
  customAlerts,
  creditorMailing,
  localCourtSearch,
  advancedSearch,
  relatedTransactions,
  claimDocuments,
});



// WEBPACK FOOTER //
// ./src/redux/reducers/rootReducer.js